module.exports = __webpack_public_path__ + "static/media/divert.a8443123.png";